export const DEFAULT_HOME_CONTENT = {
  seo: {
    title: 'Sustainable Commercial Real Estate',
    description:
      'Explore Strashin Developments’ 501 Alliance campus — a next-generation, low-carbon workspace designed for high-performing teams.',
  },
  hero: {
    eyebrow: 'Flagship Property',
    title: '501 Alliance — Toronto’s next-generation green office campus',
    description:
      'Powered by rooftop solar and geothermal systems, 501 Alliance delivers low-carbon operations, optimized air quality, and smart building efficiency—helping teams work better and tread lighter.',
  },
  heroMedia: {
    label: '501 Alliance',
    location: 'Junction Triangle, Toronto',
    ariaLabel: 'Interview video at 501 Alliance',
    url: '',
    mediaType: 'video',
  },
  availability: {
    eyebrow: 'Featured Availability',
    title: 'Units Available Now',
    description:
      'Browse every published available unit in our portfolio, grouped by property. Jump straight into the details to see rent, size, and timing.',
    ctaLabel: 'View property portfolio',
    ctaHref: '/availabilities',
  },
  availabilityMessages: {
    emptyMessage: 'No units are published right now. Check back soon for new availability.',
    errorMessage: 'We’re unable to load availability right now.',
  },
  contact: {
    heading: 'Contact us',
    description: 'Reach out for leasing, tenant services, and partnership inquiries.',
  },
} as const;
